// Auto-generated by scripts/generate-app-build-version.js — do not edit
export const APP_BUILD_VERSION = "v.7.12.2026_19.30";
